import { action, observable, makeObservable } from 'mobx';

class ReBetStore {
  reBetInfo = [];

  isReBetClick = false;

  constructor() {
    makeObservable(this, {
      isReBetClick: observable,
      reBetInfo: observable.deep,
      setReBetInfo: action.bound,
      setIsReBetClick: action.bound,
    });
  }

  setReBetInfo(pigsReBetData) {
    this.reBetInfo = pigsReBetData;
  }

  setIsReBetClick(boolValue) {
    this.isReBetClick = boolValue;
  }
}

export const reBetStore = new ReBetStore();
